import React from "react";
import HorizontalTablet from "../../assets/icons/tablet_horizontal.svg";
import VerticalTablet from "../../assets/icons/tablet_vertical.svg";

interface EmptyStateProps {
  isClassPage?: boolean;
  children: React.ReactChild;
}
const EmptyState = ({ isClassPage, children }: EmptyStateProps) => (
  <div className="emptyState">
    <img src={isClassPage ? HorizontalTablet : VerticalTablet} alt="" aria-hidden />
    <p>{children}</p>
  </div>
);

export default EmptyState;
